/**
 * src/modules/dashboard/componentes/indicadoresredes.js
 * -----------------------------------------------------------------------------
 * Componente para exibição de indicadores por redes.
 * - Recebe dados por props.
 * - Exibe filtros aplicados no topo.
 * - Usa GraficoHeatmapProduto para renderizar os gráficos.
 */

import React from 'react';
import './indicadoresredes.scss';
import { GraficoHeatmapProduto } from '../../../components/graficos/heatmapproduto';

function HeatmapBox({
  categoriaId,
  descricaoCategoria,
  listaDeIndicadoresLojas,
  semdadosparaexibir
}) {
  return (
    <div
      id={`graficos-chart-box-${categoriaId}`}
      className="box-indicadores-graficos box-content heatmap-wrap"
    >
      <div className="graficos-chart-box-action-title">
        <h3>{descricaoCategoria}</h3>
      </div>

      <GraficoHeatmapProduto
        id={categoriaId}
        grafico={listaDeIndicadoresLojas || []}
        semdadosparaexibir={semdadosparaexibir}
        hint={true}
        customHint={true}
        tag={{ lista: 'listaDeLojasIndicador', descricao: 'descricaoIndicador' }}
      />
    </div>
  );
}

export default function IndicadoresRedes({
  title,
  escopo,
  payloadData = {}, // ← Usar payloadData que já está sendo passado
  nls = {},          
  componentNls = {}, 
  autor,
  filtros = [] ,
  totaldata      
}) {
  const t = {
    semdadosparaexibir: componentNls?.semdadosparaexibir || nls?.semdadosparaexibir || 'Sem dados para exibir',
    periodo: componentNls?.periodo || nls?.periodo || 'Período'
  };

  // ✅ CORREÇÃO: Usar payloadData diretamente
  const categorias = payloadData?.listaDeIndicadoresCategoria || [];

  console.log("PayloadData recebido:", payloadData);
  console.log("Categorias extraídas:", categorias);

  return (
    <>
    <section className="box-indicadores box-content-like">
      {/* ✅ BLOCO DE FILTROS APLICADOS — IDÊNTICO AO FEEDBACK LOJAS */}
      {filtros.length > 0 && (
        <div className="feedback-filtros-aplicados">
          <p className="filtros-label">{nls?.filtrosAplicados || 'Filtros aplicados'}:</p>
          <ul className="filtros-lista">
            {filtros.map((filtro, idx) => (
              <li key={idx} className="filtro-item">
                <strong>{filtro.nomedofiltro}:</strong> {filtro.valordofiltro}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Conteúdo principal */}
      {categorias.length === 0 ? (
        <div className="companyind-empty">{t.semdadosparaexibir}</div>
      ) : (
        categorias.map((categoria) => (
          <HeatmapBox
            key={categoria.categoriaId}
            categoriaId={categoria.categoriaId}
            descricaoCategoria={categoria.descricaoCategoria}
            listaDeIndicadoresLojas={categoria.listaDeIndicadoresLojas}
            semdadosparaexibir={t.semdadosparaexibir}
          />
        ))
      )}
    </section>
     {totaldata !== null && totaldata !== undefined && (
      <div className="feedback-totaldata-outside">
        {nls?.numerodefeedbacks}: <strong>{totaldata}</strong>
      </div>
    )}
  </>
  );
}


/*
JSON INPUT

    {
      "nls": {
        "semdadosparaexibir": "No data"
      },
      "label": "Principais Assuntos - Redes",
      "scope": {
        "periodo": {
          "fim": "2025-09-30",
          "ini": "2025-09-01"
        },
        "projetoId": 47
      },
      "params": {
        "idiomaId": 2,
        "empresaId": 235
      },
      "Filtros": [
        {
          "nomedofiltro": "Empresa",
          "valordofiltro": "Assaí"
        },
        {
          "nomedofiltro": "Categoria",
          "valordofiltro": "Todas"
        }
      ],
      "ordinal": 26,
      "topicKey": "indicadoresredes"
    }





*/